
import { Product } from '@/lib/supabase/products/types';
import { OrderFormData } from './types';

// Function to push data to the dataLayer
export const pushToDataLayer = (
  eventId: string,
  product: Product,
  formData: OrderFormData,
  orderResult: any,
  organizationId: string | null,
  shopId: string | undefined
) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    console.warn("DataLayer not available for tracking");
    return;
  }

  // Calculate total value
  const value = (product.discount_price || product.price) * formData.quantity;
  
  try {
    // Push purchase event to dataLayer
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        purchase: {
          actionField: {
            id: orderResult?.id || eventId,
            affiliation: 'Scaloo Store',
            revenue: value,
            tax: 0,
            shipping: 0,
            coupon: ''
          },
          products: [{
            name: product.name,
            id: product.id,
            price: product.discount_price || product.price,
            brand: product.brand || '',
            category: product.category || '',
            variant: '',
            quantity: formData.quantity,
            coupon: ''
          }]
        }
      },
      shopId: shopId,
      organizationId: organizationId
    });
    
    console.log("Purchase event pushed to dataLayer:", {
      orderId: orderResult?.id || eventId,
      products: [product.name],
      value: value,
      currency: product.currency || "DZD"
    });

  } catch (error) {
    console.error("Error pushing to dataLayer:", error);
  }
  
  // Also track with Facebook Pixel if available
  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Purchase', {
        value: value,
        currency: product.currency || 'DZD',
        content_name: product.name,
        content_type: 'product',
        content_ids: [product.id],
        contents: [{
          id: product.id,
          quantity: formData.quantity,
          item_price: product.discount_price || product.price
        }],
        event_id: eventId
      });
      console.log("Purchase event sent to Meta Pixel");
    }
  } catch (error) {
    console.error("Error sending to Meta Pixel:", error);
  }
};

// Function to track order creation server-side
export const trackOrderCreation = async (params: {
  product: Product;
  effectiveOrgId: string | null;
  effectiveShopId: string | undefined;
  eventId: string;
  externalId: string;
  formData: OrderFormData;
  result: any;
}) => {
  try {
    const { product, effectiveOrgId, effectiveShopId, eventId, externalId, formData, result } = params;
    const value = (product.discount_price || product.price) * formData.quantity;
    
    // Make server-side tracking call
    const trackingEndpoint = '/api/tracking/track-purchase';
    
    const trackingPayload = {
      event_id: eventId,
      external_id: externalId,
      organization_id: effectiveOrgId,
      shop_id: effectiveShopId,
      value: value,
      currency: product.currency || 'DZD',
      order_id: result.id,
      product_id: product.id,
      product_name: product.name,
      quantity: formData.quantity,
      user_data: {
        name: formData.customerName,
        phone: formData.customerPhone,
        email: formData.customerEmail || '',
        address: formData.customerAddress || '',
        region: formData.customerRegion || ''
      }
    };
    
    // Optional server-side tracking - don't wait for it
    fetch(trackingEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(trackingPayload)
    }).catch(error => {
      console.warn("Server-side tracking failed, but continuing:", error);
    });
    
  } catch (error) {
    console.warn("Error in server-side tracking, but continuing:", error);
  }
};
